export default {
	ActionCapabilityRisk: Object.freeze({
		Ok: {
			value: 0,
			text: "Ação permitida",
			icon: "mdi-check-circle-outline",
			color: "green",
			severity: "success",
			canProceed: true,
			canOverride: false,
		},
		Warning: {
			value: 1,
			text: "Ação permitida com ressalvas",
			icon: "mdi-alert-circle-outline",
			color: "orange darken-1",
			severity: "warning",
			canProceed: false,
			canOverride: true,
		},
		Block: {
			value: 2,
			text: "Ação bloqueada",
			icon: "mdi-close-octagon-outline",
			color: "red darken-2",
			severity: "error",
			canProceed: false,
			canOverride: false,
		},

		Map: {
			0: "Ok",
			1: "Warning",
			2: "Block",
		},
	}),
	PriceSource: Object.freeze({
		Base: {
			value: 0,
			text: "Preço base",
			icon: "mdi-currency-usd",
			color: "grey",
			description: "Preço original do produto sem ajustes.",
		},
		List: {
			value: 1,
			text: "Tabela de preços aplicada",
			icon: "mdi-tag",
			color: "orange",
			description: "Valor calculado com base no percentual da tabela.",
		},
		Special: {
			value: 2,
			text: "Preço especial negociado",
			icon: "mdi-star",
			color: "green",
			description: "Preço negociado especificamente para este cliente.",
		},
		Manual: {
			value: 3,
			text: "Preço definido manualmente",
			icon: "mdi-progress-pencil",
			color: "primary",
			description: "Preço definido e fixado manualmente pelo usuário.",
		},
		Restored: {
			value: 4,
			text: "Preço reaplicado automaticamente",
			icon: "mdi-history",
			color: "blue-grey",
			description: "Preço anteriormente definido e reaplicado automaticamente.",
		},

		Map: {
			0: "Base",
			1: "List",
			2: "Special",
			3: "Manual",
			4: "Restored",
		},
	}),
	CommissionSource: Object.freeze({
		None: {
			value: 0,
			text: "Não possui comissão externa",
			icon: "mdi-label-percent-outline",
			color: "grey",
		},
		ClientProduct: {
			value: 1,
			text: "Produto do cliente",
			icon: "mdi-account-box-outline",
			color: "blue lighten-1",
		},
		ClientSubclass: {
			value: 2,
			text: "Subclasse do cliente",
			icon: "mdi-account-group-outline",
			color: "cyan lighten-1",
		},
		Client: {
			value: 3,
			text: "Cliente",
			icon: "mdi-account-outline",
			color: "indigo lighten-1",
		},
		SellerProduct: {
			value: 4,
			text: "Produto do vendedor",
			icon: "mdi-briefcase-outline",
			color: "green lighten-1",
		},
		SellerSubclass: {
			value: 5,
			text: "Subclasse do vendedor",
			icon: "mdi-briefcase-variant-outline",
			color: "lime darken-1",
		},
		Seller: {
			value: 6,
			text: "Vendedor",
			icon: "mdi-account-tie-outline",
			color: "teal lighten-1",
		},
		Manual: {
			value: 7,
			text: "Comissão definida manualmente",
			icon: "mdi-progress-pencil",
			color: "primary",
		},
		Restored: {
			value: 8,
			text: "Comissão reaplicada automaticamente",
			icon: "mdi-history",
			color: "blue-grey",
		},

		Map: {
			0: "None",
			1: "ClientProduct",
			2: "ClientSubclass",
			3: "Client",
			4: "SellerProduct",
			5: "SellerSubclass",
			6: "Seller",
			7: "Manual",
			8: "Restored",
		},
	}),
	VdqtipoType: Object.freeze({
		Budget: {
			text: "Pedido de orçamento",
			icon: "mdi-currency-usd",
			color: "purple lighten-1",
			textColor: "white",
		},
		Selling: {
			text: "Pedido de venda",
			icon: "mdi-cash-register",
			color: "indigo lighten-1",     
			textColor: "white",
		},
		Returning: {
			text: "Pedido de retorno",
			icon: "mdi-archive-arrow-up-outline",
			color: "brown lighten-1",       
			textColor: "white",
		},
		LoanReturning: {
			text: "Pedido de retorno de comodato",
			icon: "mdi-archive-refresh-outline",
			color: "pink lighten-1",      
			textColor: "white",
		},

		Map: {
			1: "Budget",
			2: "Selling",
			3: "Returning",
			4: "LoanReturning",
		}
	}),
	Vdpstatus: Object.freeze({
		Sale: {
			value: 1,
			text: "Venda",
			icon: "mdi-wallet-bifold-outline",
			color: "teal lighten-1",
		},
		Loan: {
			value: 2,
			text: "Comodato",
			icon: "mdi-handshake-outline",
			color: "indigo lighten-1",
		},
		SaleLoan: {
			value: 3,
			text: "Venda + Comodato",
			icon: "mdi-wallet-bifold-outline",
			leftIcon: "mdi-handshake-outline",
			color: "blue lighten-1",
		},
		Return: {
			value: 4,
			text: "Retorno",
			icon: "mdi-archive-arrow-up-outline",
			color: "deep-orange lighten-1",
		},
		LoanReturn: {
			value: 5,
			text: "Retorno de comodato",
			icon: "mdi-archive-refresh-outline",
			color: "amber darken-2",
		},
		ReturnLoanReturn: {
			value: 6,
			text: "Retorno + Retorno de comodato",
			icon: "mdi-archive-arrow-up-outline",
			leftIcon: "mdi-archive-refresh-outline",
			color: "cyan lighten-1",
		},
		FreeExchange: {
			value: 7,
			text: "Livre troca",
			icon: "mdi-swap-horizontal",
			color: "yellow darken-2"
		}
	}),
	Vdqstatus: Object.freeze({
		Opened: {
			value: 0,
			text: "Pedido em aberto",
			description: "Pedido criado e aguardando conferência",
			icon: "mdi-file-plus-outline",
			color: "amber lighten-1",
			textColor: "white",
		},
		Denied: {
			value: 1,
			text: "Orçamento reprovado",
			description:
			"Orçamento criado e recusado pelo cliente ou reprovado por erro pelo próprio vendedor.",
			icon: "mdi-file-document-remove-outline",
			color: "red darken-2",
			textColor: "white",
		},
		Approved: {
			value: 2,
			text: "Pedido aprovado",
			description:
			"Pedido conferido e liberado para seguir (ou aguardando logística).",
			icon: "mdi-file-document-check-outline",
			color: "light-green darken-1",
			textColor: "white",
		},
		WaitingForPickup: {
			value: 3,
			text: "Pedido aguardando retirada",
			description: "Pedido aguarda a retirada pelo cliente.",
			icon: "mdi-store-clock",
			leftIcon: "mdi-walk",
			color: "deep-orange lighten-1",
			textColor: "white",
		},
		WaitingExpedition: {
			value: 4,
			text: "Pedido aguardando expedição",
			description:
			"Pedido já passou pela logística e aguarda separação e carregamento.",
			icon: "mdi-truck-cargo-container",
			color: "blue lighten-1",
			textColor: "white",
		},
		WaitingForBilling: {
			value: 5,
			text: "Pedido aguardando faturamento",
			description:
			"Pedido já separado e carregado e aguarda o faturamento das notas dos itens.",
			icon: "mdi-file-document-edit-outline",
			color: "cyan darken-1",
			textColor: "white",
		},
		Billed: {
			value: 6,
			text: "Pedido faturado",
			description: "Pedido com documento fiscal já emitido.",
			icon: "mdi-receipt-text-check-outline",
			color: "teal lighten-1",
			textColor: "white",
		},
		InRoute: {
			value: 7,
			text: "Pedido em rota de entrega",
			description: "Pedido saiu para entrega em uma viagem.",
			icon: "mdi-truck-delivery-outline",
			leftIcon: "mdi-road-variant",
			color: "indigo lighten-1",
			textColor: "white",
		},
		Delivered: {
			value: 8,
			text: "Pedido entregue",
			description: "Pedido entregue ao cliente, assinatura e foto coletadas.",
			icon: "mdi-package-variant-closed-check",
			leftIcon: "mdi-check-circle-outline",
			color: "green lighten-1",
			textColor: "white",
		},
		Cancelled: {
			value: 9, 
			text: "Pedido cancelado",
			description: "Pedido foi cancelado.",
			icon: "mdi-package-variant-closed-remove",
			leftIcon: "mdi-cancel",
			color: "red lighten-1",
			textColor: "white",
		},
	}),
	CommissionGridMessage: Object.freeze({
		0: { name: 'Não possui comissão.' },
		1: { name: 'Percentual de comissão obtido a partir do produto do cliente.' },
		2: { name: 'Percentual de comissão obtido a partir da subclasse do cliente.' },
		3: { name: 'Percentual de comissão obtido a partir do cliente.' },
		4: { name: 'Percentual de comissão obtido a partir do produto do vendedor.' },
		5: { name: 'Percentual de comissão obtido a partir da subclasse do vendedor.' },
		6: { name: 'Percentual de comissão obtido a partir do vendedor.' },
	}),
	LeaseArrangementMode: Object.freeze({
		CUSTOMER: "customer",
		ADDRESS: "address",
		GROUP: "group",
	}),
	LeaseArrangementKey: Object.freeze({
		WITHOUT_ADDRESS: "withoutAddress",
		ADDRESS_WITHOUT_GROUP: "addressWithoutGroup",
	}),
	LeaseArrangementPrefix: Object.freeze({
		MANUAL_GROUP: "manualGroup",
		DISPLAY_LEASE: "displayLease",
	}),
	LeaseClosingFields: Object.freeze([
		"vd4conpgto",
		"vd4nome",
		"sinceVigen",
		"untilVigen",
		"especificObserv",
	]),
	CylinderMovementTypes: Object.freeze({
		0: { name: 'Emitido', color: 'green' },
		1: { name: 'Cancelado', color: 'red' },
	}),
	OryxTypes: Object.freeze({
		Caracter: "C",
		Number: "N",
		Memo: "M",
		Datetime: "T",
		Date: "D",
		Logical: "L",
		Currency: "Y",
		Blob: "B",
	}),
	AuditLogActionTypes: Object.freeze({
		Inclusão: "I",
		Atualização: "A",
		Exclusão: "E",
		Falha: "F",
		Agendador: "S",
		Observação: "O",
	}),
	Dc1EdicaoType: Object.freeze({
		Normal: 0,
		Insert: 1,
		NotEditable: 2,
		Invisible: 3,
	}),
	SalesOperationType: Object.freeze({
		None: 0,
		Sales: 1,
		Return: 2,
		ConsignmentInput: 3,
		ConsignmentOutPut: 4,
		SalesConfirmation: 5,
		Input: 5,
	}),
	CodNFCE: Object.freeze({
		Nenhum: 0,
		Dinheiro: 1,
		Cheque: 2,
		CartaoDeCredito: 3,
		CartaoDeDebito: 4,
		Crediario: 5,
		ValeAlimentacao: 10,
		ValeRefeicao: 11,
		ValePresente: 12,
		ValeCombustivel: 13,
		BlqBancario: 15,
		DepositoBancario: 16,
		PixDinamico: 17,
		TransferenciaBancaria: 18,
		CashBack: 19,
		PixEstatico: 20,
		SemPagamento: 90,
		Outros: 99,
	}),
	OryxModulesType: Object.freeze({
		ORYX_GESTAO: 0,
		ORYX_PV: 1,
		ORYX_LOGISTICA: 2,
		ORYX_PLACE: 3,
		ORYX_MEMORIES: 4,
		ORYX_ESQUADRIAS: 5,
	}),
	PaymFormCV8: Object.freeze({
		CONPGTO: 0,
		MANUAL: 1,
	}),
	OryxWhatsAppInformationType: Object.freeze({
		NONE: 0,
		ORDER: 1,
		LEASE: 3,
	}),
	SalesItemType: Object.freeze({
		MATERIALS: 0,
		PRODUCTS: 1,
		IN_MANUFACTURING: 2,
	}),
	PayloadCustomerType: Object.freeze({
		ERROR: 0,
		OPEN: 1,
		NOT_OPEN: 2,
	}),
	LogisticIntegrationType: Object.freeze({
		NONE: 0,
		MELHORENVIO: 1,
	}),
	PostageTagStatusType: Object.freeze({
		NONE: 0,
		CREATED: 1,
		PENDING: 2,
		PAYED: 3,
		RELEASED: 4,
		POSTED: 5,
		DELIVERED: 6,
		CANCELED: 7,
		CREATED_MANUALLY: 8,
	}),
	FreightType: Object.freeze({
		NONE: 0,
		ISSUER: 1,
		RECEIVER: 2,
		THIRD_PARTIES: 3,
		NO_SHIPPING: 4,
	}),
	PresenceIndicatorType: Object.freeze({
		NONE: 0,
		IN_PERSON: 1,
		ONLINE: 2,
	}),
	ShoppingIntegrationType: Object.freeze({
		NONE: 0,
		SIMPLES_TI: 1,
		INTEGRA_SH: 2,
		EZETECH: 3,
		IBASI: 4,
	}),
	BatchStatusType: Object.freeze({
		DISAPPROVED: 0,
		APPROVED: 1,
		PENDING: 2,
	}),
	FiscalDocumentType: Object.freeze([
		{ value: "00", text: "Nota Fiscal Municipal" },
		{ value: "01", text: "Nota Fiscal" },
		{ value: "1B", text: "Nota Fiscal Avulsa" },
		{ value: "02", text: "Nota Fiscal de Venda a Consumidor" },
		{ value: "2D", text: "Cupom Fiscal" },
		{ value: "2E", text: "Cupom Fiscal Bilhete de Passagem" },
		{ value: "04", text: "Nota Fiscal de Produtor" },
		{ value: "06", text: "Nota Fiscal de Energia Elétrica" },
		{ value: "07", text: "Nota Fiscal de Serviço de Transporte" },
		{ value: "08", text: "Conhecimento de Transporte Rodoviário de Cargas" },
		{ value: "8B", text: "Conhecimento de Transporte de Cargas Avulso" },
		{ value: "09", text: "Conhecimento de Transporte Aquaviário de Cargas" },
		{ value: "10", text: "Conhecimento Aéreo" },
		{ value: "11", text: "Conhecimento de Transporte Ferroviário de Cargas" },
		{ value: "13", text: "Bilhete de Passagem Rodoviário" },
		{ value: "14", text: "Bilhete de Passagem Aquaviário" },
		{ value: "15", text: "Bilhete de Passagem e Nota de Bagagem" },
		{ value: "17", text: "Despacho de Transporte" },
		{ value: "16", text: "Bilhete de Passagem Ferroviário" },
		{ value: "18", text: "Resumo de Movimento Diário" },
		{ value: "20", text: "Ordem de Coleta de Cargas" },
		{ value: "21", text: "Nota Fiscal de Serviço de Comunicação" },
		{ value: "22", text: "Nota Fiscal de Serviço de Telecomunicação" },
		{ value: "23", text: "GNRE" },
		{ value: "24", text: "Autorização de Carregamento e Transporte" },
		{ value: "25", text: "Manifesto de Carga" },
		{ value: "26", text: "Conhecimento de Transporte Multimodal de Cargas" },
		{ value: "27", text: "Nota Fiscal De Transporte Ferroviário De Carga" },
		{ value: "28", text: "Nota Fiscal de Fornecimento de Gás Canalizado" },
		{ value: "29", text: "Nota Fiscal De Fornecimento de água Canalizada" },
		{ value: "55", text: "Nota Fiscal Eletrônica" },
		{ value: "57", text: "Conhecimento de Transporte Eletrônico" },
		{ value: "58", text: "MDFe" },
		{ value: "65", text: "Cupom Fiscal Eletrônico" },
		{ value: "67", text: "Outros Serviços de Transporte" },
		{ value: "99", text: "Documento Interno" },
	]),
	IntegrationType: Object.freeze([
		{ value: "0", text: "Nenhum" },
		{ value: "1", text: "Pagamento integrado" },
		{ value: "2", text: "Pagamento não integrado" },
	]),
	CodigoNFCEType: Object.freeze([
		{ value: "00", text: "Nenhum", addTariff: false, dynamicTariff: false },
		{ value: "01", text: "Dinheiro", addTariff: false, dynamicTariff: false },
		{ value: "02", text: "Cheque", addTariff: false, dynamicTariff: false },
		{ value: "03", text: "Cartão de crédito", addTariff: true, dynamicTariff: true },
		{ value: "04", text: "Cartão de débito", addTariff: true, dynamicTariff: true },
		{ value: "05", text: "Crediário", addTariff: false, dynamicTariff: false },
		{ value: "10", text: "Vale alimentação", addTariff: false, dynamicTariff: false },
		{ value: "11", text: "Vale refeição", addTariff: false, dynamicTariff: false },
		{ value: "12", text: "Vale presente", addTariff: false, dynamicTariff: false },
		{ value: "13", text: "Vale combustível", addTariff: false, dynamicTariff: false },
		{ value: "15", text: "Bloqueio bancário", addTariff: true, dynamicTariff: true },
		{ value: "16", text: "Depósito bancário", addTariff: false, dynamicTariff: false },
		{ value: "17", text: "PIX Dinâmico", addTariff: true, dynamicTariff: false },
		{ value: "18", text: "Transferência bancária", addTariff: false, dynamicTariff: false },
		{ value: "19", text: "CashBack", addTariff: false, dynamicTariff: false },
		{ value: "20", text: "PIX Estático", addTariff: true, dynamicTariff: false },
		{ value: "90", text: "Sem pagamento", addTariff: false, dynamicTariff: false },
		{ value: "99", text: "Outros", addTariff: false, dynamicTariff: false },
	]),
	TEFTransactionStateType: Object.freeze({
		STARTED: 0,
		COMPLETED: 1,
		CANCELED: 2,
		ERROR: 3,
		EXECUTED: 4,
		REJECTED: 5,
		EXECUTED_LATER: 6,
	}),
	TEFHouse: Object.freeze({
		NENHUM: 1,
		DESTAXA: 1,
	}),
	GoodsFlowType: Object.freeze([
		{ value: 0, text: "Nenhum" },
		{ value: 1, text: "Saída de mercadorias" },
		{ value: 2, text: "Entrada de mercadorias" },
		{ value: 3, text: "Ingresso" },
		{ value: 4, text: "Desembolso" },
		{ value: 5, text: "Rastreabilidade" },
	]),
	GoodsFlowTypeEnum: Object.freeze({
		NONE: 0,
		GOODS_EXIT: 1,
		GOODS_ENTRY: 2,
		GOODS_RECEIVING: 3,
		DISBURSEMENT: 4,
		TRACEABILITY: 5,
	}),
	LiquidationSideType: Object.freeze({
		RECEIVE: "receive",
		PAY: "pay",
	}),
	CSTType: Object.freeze([
		{ value: "00", text: "Tributação Integral" },
		{ value: "10", text: "Tributada e com cobrança do ICMS por substituição tributária" },
		{ value: "20", text: "Tributação do ICMS Com redução de base de cálculo" },
		{ value: "30", text: "Tributação do ICMS apenas por substituição tributária" },
		{ value: "40", text: "Isenta" },
		{ value: "41", text: "Não Tributada" },
		{ value: "50", text: "Suspensão" },
		{ value: "51", text: "Diferimento" },
		{ value: "60", text: "Tributado anteriormente por ST" },
		{ value: "90", text: "Outros" },
		{ value: "101", text: "Tributada pelo Simples Nacional com permissão de crédito." },
		{ value: "102", text: "Tributada pelo Simples Nacional sem permissão de crédito." },
		{ value: "103", text: "Isenção do ICMS no Simples Nacional para faixa de receita bruta." },
		{
			value: "201",
			text: "Tributada pelo Simples Nacional com permissão de crédito e com cobrança do ICMS por Substituição Tributária",
		},
		{
			value: "202",
			text: "Tributada pelo Simples Nacional sem permissão de crédito e com cobrança do ICMS por Substituição Tributária",
		},
		{
			value: "203",
			text: "Isenção do ICMS nos Simples Nacional para faixa de receita bruta e com cobrança do ICMS por Substituição Tributária",
		},
		{ value: "300", text: "Imune" },
		{ value: "400", text: "Não tributada pelo Simples Nacional" },
		{ value: "900", text: "Tributação do ICMS. Outros" },
	]),
	VolumeType: Object.freeze([
		{ value: 0, text: "Nenhum" },
		{ value: 1, text: "Avulso" },
		{ value: 2, text: "Caixa" },
		{ value: 3, text: "Volume" },
	]),
	FreightTypeDescription: Object.freeze([
		{ value: 0, text: "Nenhum" },
		{ value: 1, text: "Emitente" },
		{ value: 2, text: "Destinatário" },
		{ value: 3, text: "Terceiro" },
		{ value: 4, text: "Sem frete" },
	]),
	SellingItemType: Object.freeze([
		{ value: 0, text: "Materiais" },
		{ value: 1, text: "Produtos" },
		{ value: 2, text: "Em Fabricação" },
	]),
	ServiceCodeType: Object.freeze([
		{
			value: "15.02",
			text: "Abertura de contas em geral, inclusive conta-corrente, conta de investimentos e aplicação e caderneta de poupança, no País e no exterior, bem como a manutenção das referidas contas ativas e inativas.",
		},
		{
			value: "15.07",
			text: "Acesso, movimentação, atendimento e consulta a contas em geral, por qualquer meio ou processo, inclusive por telefone, fac-símile, Internet e telex, acesso a terminais de atendimento, inclusive vinte e quatro horas; acesso a outro ban",
		},
		{
			value: "7.19",
			text: "Acompanhamento e fiscalização da execução de obras de engenharia, arquitetura e urbanismo.",
		},
		{ value: "4.05", text: "Acupuntura." },
		{
			value: "15.01",
			text: "Administração de fundos quaisquer, de consórcio, de cartão de crédito ou débito e congêneres, de carteira de clientes, de cheques pré-datados e congêneres.",
		},
		{ value: "17.12", text: "Administração em geral, inclusive de bens e negócios de terceiros." },
		{ value: "17.14", text: "Advocacia." },
		{
			value: "7.20",
			text: "Aerofotogrametria (inclusive interpretação), cartografia, mapeamento, levantamentos topográficos, batimétricos, geográficos, geodésicos, geológicos, geofísicos e congêneres.",
		},
		{ value: "10.07", text: "Agenciamento de notícias." },
		{
			value: "10.08",
			text: "Agenciamento de publicidade e propaganda, inclusive o agenciamento de veiculação por quaisquer meios.",
		},
		{ value: "10.06", text: "Agenciamento marítimo." },
		{
			value: "10.05",
			text: "Agenciamento, corretagem ou intermediação de bens móveis ou imóveis, não abrangidos em outros itens ou subitens, inclusive aqueles realizados no âmbito de Bolsas de Mercadorias e Futuros, por quaisquer meios.",
		},
		{
			value: "10.04",
			text: "Agenciamento, corretagem ou intermediação de contratos de arrendamento mercantil (leasing), de franquia (franchising) e de faturização (factoring).",
		},
		{
			value: "10.01",
			text: "Agenciamento, corretagem ou intermediação de câmbio, de seguros, de cartões de crédito, de planos de saúde e de planos de previdência privada.",
		},
		{
			value: "10.03",
			text: "Agenciamento, corretagem ou intermediação de direitos de propriedade industrial, artística ou literária.",
		},
		{
			value: "10.02",
			text: "Agenciamento, corretagem ou intermediação de títulos em geral, valores mobiliários e contratos quaisquer.",
		},
		{
			value: "9.02",
			text: "Agenciamento, organização, promoção, intermediação e execução de programas de turismo, passeios, viagens, excursões, hospedagens e congêneres.",
		},
		{
			value: "14.09",
			text: "Alfaiataria e costura, quando o material for fornecido pelo usuário final, exceto aviamento.",
		},
		{ value: "17.17", text: "Análise de Organização e Métodos." },
		{ value: "1.01", text: "Análise e desenvolvimento de sistemas." },
		{
			value: "4.02",
			text: "Análises clínicas, patologia, eletricidade médica, radioterapia, quimioterapia, ultra-sonografia, ressonância magnética, radiologia, tomografia e congêneres.",
		},
		{ value: "17.24", text: "Apresentação de palestras, conferências, seminários e congêneres." },
		{ value: "17.15", text: "Arbitragem de qualquer espécie, inclusive jurídica." },
		{
			value: "11.04",
			text: "Armazenamento, depósito, carga, descarga, arrumação e guarda de bens de qualquer espécie.",
		},
		{
			value: "15.09",
			text: "Arrendamento mercantil (leasing) de quaisquer bens, inclusive cessão de direitos e obrigações, substituição de garantia, alteração, cancelamento e registro de contrato, e demais serviços relacionados ao arrendamento mercantil (leasing",
		},
		{ value: "1.06", text: "Assessoria e consultoria em informática." },
		{
			value: "17.01",
			text: "Assessoria ou consultoria de qualquer natureza, não contida em outros itens desta lista; análise, exame, pesquisa, coleta, compilação e fornecimento de dados e informações de qualquer natureza, inclusive cadastro e similares.",
		},
		{
			value: "17.23",
			text: "Assessoria, análise, avaliação, atendimento, consulta, cadastro, seleção, gerenciamento de informações, administração de contas a receber ou a pagar e em geral, relacionados a operações de faturização (factoring).",
		},
		{ value: "14.02", text: "Assistência técnica." },
		{ value: "17.18", text: "Atuária e cálculos técnicos de qualquer natureza." },
		{ value: "17.16", text: "Auditoria." },
		{ value: "5.05", text: "Bancos de sangue e de órgãos e congêneres." },
		{ value: "4.19", text: "Bancos de sangue, leite, pele, olhos, óvulos, sêmen e congêneres." },
		{ value: "6.03", text: "Banhos, duchas, sauna, massagens e congêneres." },
		{ value: "6.01", text: "Barbearia, cabeleireiros, manicuros, pedicuros e congêneres." },
		{ value: "12.09", text: "Bilhares, boliches e diversões eletrônicas ou não." },
		{ value: "12.06", text: "Boates, taxi-dancing e congêneres." },
		{
			value: "15.05",
			text: "Cadastro, elaboração de ficha cadastral, renovação cadastral e congêneres, inclusão ou exclusão no Cadastro de Emitentes de Cheques sem Fundos - CCF ou em quaisquer outros bancos cadastrais.",
		},
		{ value: "7.08", text: "Calafetação." },
		{ value: "14.13", text: "Carpintaria e serralheria." },
		{ value: "4.17", text: "Casas de repouso e de recuperação, creches, asilos e congêneres." },
		{ value: "6.05", text: "Centros de emagrecimento, spa e congêneres." },
		{ value: "3.05", text: "Cessão de andaimes, palcos, coberturas e outras estruturas de uso temporário." },
		{ value: "3.02", text: "Cessão de direito de uso de marcas e de sinais de propaganda." },
		{ value: "17.22", text: "Cobrança em geral." },
		{
			value: "4.20",
			text: "Coleta de sangue, leite, tecidos, sêmen, órgãos e materiais biológicos de qualquer espécie.",
		},
		{
			value: "5.06",
			text: "Coleta de sangue, leite, tecidos, sêmen, órgãos e materiais biológicos de qualquer espécie.",
		},
		{ value: "14.07", text: "Colocação de molduras e congêneres." },
		{
			value: "7.06",
			text: "Colocação e instalação de tapetes, carpetes, assoalhos, cortinas, revestimentos de parede, vidros, divisórias, placas de gesso e congêneres, com material fornecido pelo tomador do serviço.",
		},
		{
			value: "15.15",
			text: "Compensação de cheques e títulos quaisquer; serviços relacionados a depósito, inclusive depósito identificado, a saque de contas quaisquer, por qualquer meio ou processo, inclusive em terminais eletrônicos e de atendimento.",
		},
		{
			value: "12.11",
			text: "Competições esportivas ou de destreza física ou intelectual, com ou sem a participação do espectador.",
		},
		{ value: "13.05", text: "Composição gráfica, fotocomposição, clicheria, zincografia, litografia, fotolitografia." },
		{ value: "17.20", text: "Consultoria e assessoria econômica ou financeira." },
		{ value: "17.19", text: "Contabilidade, inclusive serviços técnicos e auxiliares." },
		{
			value: "7.12",
			text: "Controle e tratamento de efluentes de qualquer natureza e de agentes físicos, químicos e biológicos.",
		},
		{ value: "12.10", text: "Corridas e competições de animais." },
		{ value: "25.02", text: "Cremação de corpos e partes de corpos cadavéricos." },
		{ value: "15.12", text: "Custódia em geral, inclusive de títulos e valores mobiliários." },
		{
			value: "17.02",
			text: "Datilografia, digitação, estenografia, expediente, secretaria em geral, resposta audível, redação, edição, interpretação, revisão, tradução, apoio e infra-estrutura administrativa e congêneres.",
		},
		{ value: "7.11", text: "Decoração e jardinagem, inclusive corte e poda de árvores." },
		{
			value: "7.13",
			text: "Dedetização, desinfecção, desinsetização, imunização, higienização, desratização, pulverização e congêneres.",
		},
		{ value: "7.04", text: "Demolição." },
		{ value: "12.15", text: "Desfiles de blocos carnavalescos ou folclóricos, trios elétricos e congêneres." },
		{
			value: "15.11",
			text: "Devolução de títulos, protesto de títulos, sustação de protesto, manutenção de títulos, reapresentação de títulos, e demais serviços a eles relacionados.",
		},
		{ value: "10.10", text: "Distribuição de bens de terceiros." },
		{
			value: "7.03",
			text: "Elaboração de planos diretores, estudos de viabilidade, estudos organizacionais e outros, relacionados com obras e serviços de engenharia; elaboração de anteprojetos, projetos básicos e projetos executivos para trabalhos de engenharia.",
		},
		{ value: "1.04", text: "Elaboração de programas de computadores, inclusive de jogos eletrônicos." },
		{
			value: "15.17",
			text: "Emissão, fornecimento, devolução, sustação, cancelamento e oposição de cheques quaisquer, avulso ou por talão.",
		},
		{
			value: "15.06",
			text: "Emissão, reemissão e fornecimento de avisos, comprovantes e documentos em geral; abono de firmas; coleta e entrega de documentos, bens e valores; comunicação com outra agência ou com a administração central; licenciamento eletrônico d",
		},
		{
			value: "15.08",
			text: "Emissão, reemissão, alteração, cessão, substituição, cancelamento e registro de contrato de crédito; estudo, análise e avaliação de operações de crédito; emissão, concessão, alteração ou contratação de aval, fiança, anuência e congêne",
		},
		{
			value: "15.16",
			text: "Emissão, reemissão, liquidação, alteração, cancelamento e baixa de ordens de pagamento, ordens de crédito e similares, por qualquer meio ou processo; serviços relacionados à transferência de valores, dados, fundos, pagamentos e simila",
		},
		{ value: "14.08", text: "Encadernação, gravação e douração de livros, revistas e congêneres." },
		{ value: "4.06", text: "Enfermagem, inclusive serviços auxiliares." },
		{
			value: "7.01",
			text: "Engenharia, agronomia, agrimensura, arquitetura, geologia, urbanismo, paisagismo e congêneres.",
		},
		{ value: "8.01", text: "Ensino regular pré-escolar, fundamental, médio e superior." },
		{ value: "11.03", text: "Escolta, inclusive de veículos e cargas." },
		{ value: "7.17", text: "Escoramento, contenção de encostas e serviços congêneres." },
		{ value: "12.03", text: "Espetáculos circenses." },
		{ value: "12.01", text: "Espetáculos teatrais." },
		{ value: "17.21", text: "Estatística." },
		{ value: "6.02", text: "Esteticistas, tratamento de pele, depilação e congêneres." },
		{ value: "12.12", text: "Execução de música." },
		{
			value: "7.02",
			text: "Execução, por administração, empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplanagem, pavi",
		},
		{
			value: "12.16",
			text: "Exibição de filmes, entrevistas, musicais, espetáculos, shows, concertos, desfiles, óperas, competições esportivas, de destreza intelectual ou congênere.",
		},
		{ value: "12.02", text: "Exibições cinematográficas." },
		{
			value: "3.03",
			text: "Exploração de salões de festas, centro de convenções, escritórios virtuais, stands, quadras esportivas, estádios, ginásios, auditórios, casas de espetáculos, parques de diversões, canchas e congêneres, para realização de eventos ou neg",
		},
		{ value: "12.08", text: "Feiras, exposições, congressos e congêneres." },
		{ value: "7.16", text: "Florestamento, reflorestamento, semeadura, adubação e congêneres." },
		{ value: "13.02", text: "Fonografia ou gravação de sons, inclusive trucagem, dublagem, mixagem e congêneres." },
		{
			value: "17.05",
			text: "Fornecimento de mão-de-obra, mesmo em caráter temporário, inclusive de empregados ou trabalhadores, avulsos ou temporários, contratados pelo prestador de serviço.",
		},
		{
			value: "12.14",
			text: "Fornecimento de música para ambientes fechados ou não, mediante transmissão por qualquer processo.",
		},
		{
			value: "15.04",
			text: "Fornecimento ou emissão de atestados em geral, inclusive atestado de idoneidade, atestado de capacidade financeira e congêneres.",
		},
		{
			value: "15.14",
			text: "Fornecimento, emissão, reemissão, renovação e manutenção de cartão magnético, cartão de crédito, cartão de débito, cartão salário e congêneres.",
		},
		{
			value: "13.03",
			text: "Fotografia e cinematografia, inclusive revelação, ampliação, cópia, reprodução, trucagem e congêneres.",
		},
		{ value: "17.08", text: "Franquia (franchising)." },
		{
			value: "25.01",
			text: "Funerais, inclusive fornecimento de caixão, urna ou esquifes; aluguel de capela; transporte do corpo cadavérico; fornecimento de flores, coroas e outros paramentos; desembaraço de certidão de óbito; fornecimento de véu, essa e outros",
		},
		{ value: "14.12", text: "Funilaria e lanternagem." },
		{ value: "6.04", text: "Ginástica, dança, esportes, natação, artes marciais e demais atividades físicas." },
		{
			value: "11.01",
			text: "Guarda e estacionamento de veículos terrestres automotores, de aeronaves e de embarcações.",
		},
		{ value: "5.08", text: "Guarda, tratamento, amestramento, embelezamento, alojamento e congêneres." },
		{ value: "9.03", text: "Guias de turismo." },
		{
			value: "9.01",
			text: "Hospedagem de qualquer natureza em hotéis, apart-service condominiais, flat, apart-hotéis, hotéis residência, residence-service, suite service, hotelaria marítima, motéis, pensões e congêneres; ocupação por temporada com fornecimento d",
		},
		{ value: "5.02", text: "Hospitais, clínicas, ambulatórios, prontos-socorros e congêneres, na área veterinária." },
		{
			value: "4.03",
			text: "Hospitais, clínicas, laboratórios, sanatórios, manicômios, casas de saúde, prontos-socorros, ambulatórios e         congêneres.",
		},
		{ value: "4.18", text: "Inseminação artificial, fertilização in vitro e congêneres." },
		{ value: "5.04", text: "Inseminação artificial, fertilização in vitro e congêneres." },
		{
			value: "14.06",
			text: "Instalação e montagem de aparelhos, máquinas e equipamentos, inclusive montagem industrial, prestados ao usuário final, exclusivamente com material por ele fornecido.",
		},
		{ value: "4.04", text: "Instrumentação cirúrgica." },
		{
			value: "8.02",
			text: "Instrução, treinamento, orientação pedagógica e educacional, avaliação de conhecimentos de qualquer natureza.",
		},
		{ value: "5.03", text: "Laboratórios de análise na área veterinária." },
		{ value: "17.13", text: "Leilão e congêneres." },
		{ value: "1.05", text: "Licenciamento ou cessão de direito de uso de programas de computação." },
		{
			value: "7.18",
			text: "Limpeza e dragagem de rios, portos, canais, baías, lagos, lagoas, represas, açudes e congêneres.",
		},
		{
			value: "7.10",
			text: "Limpeza, manutenção e conservação de vias e logradouros públicos, imóveis, chaminés, piscinas, parques, jardins e congêneres.",
		},
		{
			value: "15.03",
			text: "Locação e manutenção de cofres particulares, de terminais eletrônicos, de terminais de atendimento e de bens e equipamentos em geral.",
		},
		{
			value: "3.04",
			text: "Locação, sublocação, arrendamento, direito de passagem ou permissão de uso, compartilhado ou não, de ferrovia, rodovia, postes, cabos, dutos e condutos de qualquer natureza.",
		},
		{
			value: "14.01",
			text: "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes em",
		},
		{ value: "25.04", text: "Manutenção e conservação de jazigos e cemitérios." },
		{ value: "4.01", text: "Medicina e biomedicina." },
		{ value: "5.01", text: "Medicina veterinária e zootecnia." },
		{ value: "7.22", text: "Nucleação e bombardeamento de nuvens e congêneres." },
		{ value: "4.10", text: "Nutrição." },
		{ value: "40.01", text: "Obras de arte sob encomenda." },
		{ value: "4.11", text: "Obstetrícia." },
		{ value: "4.12", text: "Odontologia." },
		{
			value: "17.11",
			text: "Organização de festas e recepções; bufê (exceto o fornecimento de alimentação e bebidas, que fica sujeito ao ICMS).",
		},
		{ value: "4.13", text: "Ortóptica." },
		{
			value: "4.23",
			text: "Outros planos de saúde que se cumpram através de serviços de terceiros contratados, credenciados, cooperados ou apenas pagos pelo operador do plano mediante indicação do beneficiário.",
		},
		{ value: "12.05", text: "Parques de diversões, centros de lazer e congêneres." },
		{ value: "17.09", text: "Perícias, laudos, exames técnicos e análises técnicas." },
		{
			value: "7.21",
			text: "Pesquisa, perfuração, cimentação, mergulho, perfilagem, concretação, testemunhagem, pescaria, estimulação e outros serviços relacionados com a exploração e explotação de petróleo, gás natural e de outros recursos minerais.",
		},
		{ value: "1.08", text: "Planejamento, confecção, manutenção e atualização de páginas eletrônicas." },
		{
			value: "17.03",
			text: "Planejamento, coordenação, programação ou organização técnica, financeira ou administrativa.",
		},
		{
			value: "17.10",
			text: "Planejamento, organização e administração de feiras, exposições, congressos e congêneres.",
		},
		{ value: "5.09", text: "Planos de atendimento e assistência médico-veterinária." },
		{
			value: "4.22",
			text: "Planos de medicina de grupo ou individual e convênios para prestação de assistência médica, hospitalares, odontológicas e congêneres.",
		},
		{ value: "25.03", text: "Planos ou convênio funerários." },
		{ value: "1.03", text: "Processamento de dados e congêneres." },
		{
			value: "12.13",
			text: "Produção, mediante ou sem encomenda prévia, de eventos, espetáculos, entrevistas, shows, ballet, danças, desfiles, bailes, teatros, óperas, concertos, recitais, festivais e congêneres.",
		},
		{ value: "12.04", text: "Programas de auditório." },
		{ value: "1.02", text: "Programação." },
		{
			value: "17.06",
			text: "Propaganda e publicidade, inclusive promoção de vendas, planejamento de campanhas ou sistemas de publicidade, elaboração de desenhos, textos e demais materiais publicitários.",
		},
		{ value: "4.14", text: "Próteses sob encomenda." },
		{ value: "4.15", text: "Psicanálise." },
		{ value: "4.16", text: "Psicologia." },
		{ value: "14.04", text: "Recauchutagem ou regeneração de pneus." },
		{
			value: "14.03",
			text: "Recondicionamento de motores (exceto peças e partes empregadas, que ficam sujeitas ao ICMS).",
		},
		{ value: "12.17", text: "Recreação e animação, inclusive em festas e eventos de qualquer natureza." },
		{ value: "17.04", text: "Recrutamento, agenciamento, seleção e colocação de mão-de-obra." },
		{ value: "7.07", text: "Recuperação, raspagem, polimento e lustração de pisos e congêneres." },
		{
			value: "7.05",
			text: "Reparação, conservação e reforma de edifícios, estradas, pontes, portos e congêneres (exceto o fornecimento de mercadorias produzidas pelo prestador dos serviços, fora do local da prestação dos serviços, que fica sujeito ao ICMS).",
		},
		{ value: "10.09", text: "Representação de qualquer natureza, inclusive comercial." },
		{ value: "13.04", text: "Reprografia, microfilmagem e digitalização." },
		{
			value: "14.05",
			text: "Restauração, recondicionamento, acondicionamento, pintura, beneficiamento, lavagem, secagem, tingimento, galvanoplastia, anodização, corte, recorte, polimento, plastificação e congêneres, de objetos quaisquer.",
		},
		{
			value: "20.02",
			text: "Serviços aeroportuários, utilização de aeroporto, movimentação de passageiros, armazenagem de qualquer natureza, capatazia, movimentação de aeronaves, serviços de apoio aeroportuários, serviços acessórios, movimentação de mercadorias,",
		},
		{ value: "37.01", text: "Serviços de artistas, atletas, modelos e manequins." },
		{ value: "27.01", text: "Serviços de assistência social." },
		{ value: "28.01", text: "Serviços de avaliação de bens e serviços de qualquer natureza." },
		{ value: "29.01", text: "Serviços de biblioteconomia." },
		{ value: "30.01", text: "Serviços de biologia, biotecnologia e química." },
		{
			value: "24.01",
			text: "Serviços de chaveiros, confecção de carimbos, placas, sinalização visual, banners, adesivos e congêneres.",
		},
		{
			value: "26.01",
			text: "Serviços de coleta, remessa ou entrega de correspondências, documentos, objetos, bens ou valores, inclusive pelos correios e suas agências franqueadas; courrier e congêneres.",
		},
		{ value: "33.01", text: "Serviços de desembaraço aduaneiro, comissários, despachantes e congêneres." },
		{ value: "32.01", text: "Serviços de desenhos técnicos." },
		{
			value: "19.01",
			text: "Serviços de distribuição e venda de bilhetes e demais produtos de loteria, bingos, cartões, pules ou cupons de apostas, sorteios, prêmios, inclusive os decorrentes de títulos de capitalização e congêneres.",
		},
		{
			value: "22.01",
			text: "Serviços de exploração de rodovia mediante cobrança de preço ou pedágio dos usuários, envolvendo execução de serviços de conservação, manutenção, melhoramentos para adequação de capacidade e segurança de trânsito, operação, monitoraçã",
		},
		{ value: "34.01", text: "Serviços de investigações particulares, detetives e congêneres." },
		{ value: "36.01", text: "Serviços de meteorologia." },
		{ value: "38.01", text: "Serviços de museologia." },
		{
			value: "39.01",
			text: "Serviços de ourivesaria e lapidação (quando o material for fornecido pelo tomador do serviço).",
		},
		{ value: "2.01", text: "Serviços de pesquisas e desenvolvimento de qualquer natureza." },
		{ value: "23.01", text: "Serviços de programação e comunicação visual, desenho industrial e congêneres." },
		{ value: "21.01", text: "Serviços de registros públicos, cartorários e notariais." },
		{
			value: "18.01",
			text: "Serviços de regulação de sinistros vinculados a contratos de seguros; inspeção e avaliação de riscos para cobertura de contratos de seguros; prevenção e gerência de riscos seguráveis e congêneres.",
		},
		{ value: "35.01", text: "Serviços de reportagem, assessoria de imprensa, jornalismo e relações públicas." },
		{
			value: "20.03",
			text: "Serviços de terminais rodoviários, ferroviários, metroviários, movimentação de passageiros, mercadorias, inclusive     suas operações, logística e congêneres.",
		},
		{ value: "16.01", text: "Serviços de transporte de natureza municipal." },
		{ value: "4.07", text: "Serviços farmacêuticos." },
		{
			value: "20.01",
			text: "Serviços portuários, ferroportuários, utilização de porto, movimentação de passageiros, reboque de embarcações, rebocador escoteiro, atracação, desatracação, serviços de praticagem, capatazia, armazenagem de qualquer natureza, serviço",
		},
		{
			value: "15.10",
			text: "Serviços relacionados a cobranças, recebimentos ou pagamentos em geral, de títulos quaisquer, de contas ou carnês, de câmbio, de tributos e por conta de terceiros, inclusive os efetuados por meio eletrônico, automático ou por máquinas",
		},
		{
			value: "15.18",
			text: "Serviços relacionados a crédito imobiliário, avaliação e vistoria de imóvel ou obra, análise técnica e jurídica, emissão, reemissão, alteração, transferência e renegociação de contrato, emissão e reemissão do termo de quitação e demai",
		},
		{
			value: "15.13",
			text: "Serviços relacionados a operações de câmbio em geral, edição, alteração, prorrogação, cancelamento e baixa de contrato de câmbio; emissão de registro de exportação ou de crédito; cobrança ou depósito no exterior; emissão, fornecimento",
		},
		{
			value: "31.01",
			text: "Serviços técnicos em edificações, eletrônica, eletrotécnica, mecânica, telecomunicações e congêneres.",
		},
		{
			value: "12.07",
			text: "Shows, ballet, danças, desfiles, bailes, óperas, concertos, recitais, festivais e congêneres.",
		},
		{
			value: "1.07",
			text: "Suporte técnico em informática, inclusive instalação, configuração e manutenção de programas de computação e bancos de dados.",
		},
		{ value: "14.11", text: "Tapeçaria e reforma de estofamentos em geral." },
		{ value: "4.08", text: "Terapia ocupacional, fisioterapia e fonoaudiologia." },
		{ value: "4.09", text: "Terapias de qualquer espécie destinadas ao tratamento físico, orgânico e mental." },
		{ value: "14.10", text: "Tinturaria e lavanderia." },
		{ value: "4.21", text: "Unidade de atendimento, assistência ou tratamento móvel e congênere." },
		{ value: "5.07", text: "Unidade de atendimento, assistência ou tratamento móvel e congênere." },
		{
			value: "7.09",
			text: "Varrição, coleta, remoção, incineração, tratamento, reciclagem, separação e destinação final de lixo, rejeitos e outros resíduos quaisquer.",
		},
		{ value: "11.02", text: "Vigilância, segurança ou monitoramento de bens e pessoas." },
	]),
	TributaryRegimeIPIType: Object.freeze([
		{ value: "00", text: "Credito por Entrada" },
		{ value: "01", text: "Entrada alíquota zero" },
		{ value: "02", text: "Entrada isenta" },
		{ value: "03", text: "Entrada não-tributada" },
		{ value: "04", text: "Entrada imune" },
		{ value: "05", text: "Entrada com suspensão" },
		{ value: "49", text: "Outras Entradas" },
		{ value: "50", text: "Saida Tributada" },
		{ value: "51", text: "Saida alíquota zero" },
		{ value: "52", text: "Saida isenta" },
		{ value: "53", text: "Saida não-tributada" },
		{ value: "54", text: "Saida imune" },
		{ value: "55", text: "Saida com suspensão" },
		{ value: "99", text: "Outras Saidas" },
	]),
	TributaryRegimePISType: Object.freeze([
		{ value: "01", text: "Trib Aliq Normal" },
		{ value: "02", text: "Trib Aliq Difer" },
		{ value: "04", text: "Trib Aliq Zero - Monof" },
		{ value: "06", text: "Trib Aliq Zero" },
		{ value: "07", text: "Operacao Isenta" },
		{ value: "08", text: "Sem Incidencia" },
		{ value: "09", text: "Suspensão de Contrib" },
		{ value: "49", text: "Outras Saidas" },
		{ value: "50", text: "Direito a Crédito - Mercado Interno" },
		{ value: "70", text: "Aquis sem dir a credito" },
		{ value: "98", text: "Outras Entradas" },
		{ value: "99", text: "Outras Operacoes" },
	]),
	TributaryRegimeCOFINSType: Object.freeze([
		{ value: "01", text: "Trib Aliq Normal" },
		{ value: "02", text: "Trib Aliq Difer" },
		{ value: "04", text: "Trib Aliq Zero - Monof" },
		{ value: "06", text: "Trib Aliq Zero" },
		{ value: "07", text: "Operacao Isenta" },
		{ value: "08", text: "Sem Incidencia" },
		{ value: "09", text: "Suspensão de Contrib" },
		{ value: "49", text: "Outras Saidas" },
		{ value: "50", text: "Direito a Crédito - Mercado Interno" },
		{ value: "70", text: "Aquis sem dir a credito" },
		{ value: "98", text: "Outras Entradas" },
		{ value: "99", text: "Outras Operacoes" },
	]),
	CommodityOriginType: Object.freeze([
		{ value: "0", text: "Nacional" },
		{ value: "1", text: "Estrangeira" },
		{ value: "2", text: "Estrangeira - Adquirida no País" },
		{ value: "3", text: "Nacional. Cont Importado > 40% e <= 70%" },
		{ value: "4", text: "Nacional. Prod Cfe Ajuste" },
		{ value: "5", text: "Nacional. Cont Importado <= 40%" },
		{ value: "6", text: "Estrangeira. Sem similar nacional." },
		{ value: "7", text: "Estrangeira. Sem similar adquirida no país." },
		{ value: "8", text: "Nacional. Cont Importado > 70%" },
	]),
	PresenceIndicatorTypeDescription: Object.freeze([
		{ value: "0", text: "Não se aplica, NF de ajuste" },
		{ value: "1", text: "Operação presencial" },
		{ value: "2", text: "Operação não presencial, pela internet" },
		{ value: "3", text: "Operação não presencial, Teleatendimento" },
		{ value: "4", text: "NFC-e em operação com entrega a domicílio" },
		{ value: "9", text: "Operação não presencial, outros." },
	]),
	TributaryRegimeCodeTypeDescription: Object.freeze([
		{ value: "1", text: "Simples Nacional" },
		{ value: "2", text: "Simples Nacional, excesso sublimite de receita bruta" },
		{ value: "3", text: "Regime Normal" },
	]),
	TributaryRegimeCodeType: Object.freeze({
		SimplesNacional: 1,
		SimplesNacionalExcessoSublimiteReceitaBruta: 2,
		RegimeNormal: 3,
	}),
	CashierFlowType: Object.freeze({
		NONE: 0,
		EXIT: 1,
		ENTRY: 2,
	}),
	PriceListRounding: Object.freeze({
		NONE: 0,
		TENTH: 1,
		WHOLE: 2,
		WHOLE_SUPERIOR: 3,
	}),
	FiscalDocumentStatus: Object.freeze({
		E: "Emitido",
		P: "Pendente",
		C: "Cancelado",
		I: "Inutilizado",
		D: "Denegado",
	}),
	GroupingDocumentsStatus: Object.freeze({
		G: "Gerado",
		P: "Pendente",
		C: "Cancelado",
		I: "Importado",
		N: "Não Faturado",
	}),
	GroupingDocumentsStatusColor: Object.freeze({
		I: "#b39246",
		G: "green",
		P: "orange",
		C: "red",
		N: "red",
	}),
	FiscalDocumentDebitType: Object.freeze([
		{ value: "01", text: "Transferência de créditos para Cooperativas" },
		{ value: "02", text: "Anulação de Crédito por Saídas Imunes/Isentas" },
		{ value: "03", text: "Débitos de notas fiscais não processadas na apuração" },
		{ value: "04", text: "Multa e Juros" },
		{ value: "05", text: "Transferência de crédito na sucessão" },
		{ value: "06", text: "Pagamento antecipado" },
		{ value: "07", text: "Perda em estoque" },
		{ value: "08", text: "Desenquadramento do SN" },
	]),
	FiscalDocumentCreditType: Object.freeze([
		{ value: "01", text: "Multa e Juros" },
		{ value: "02", text: "Apropriação de crédito presumido de IBS sobre o saldo devedor na ZFM" },
		{ value: "03", text: "Retorno por recusa na entrega ou por não localização do destinatário na tentativa de entrega" },
		{ value: "04", text: "Redução de valores" },
		{ value: "05", text: "Transferência de crédito na sucessão" },
	]),
	GovernmentEntityType: Object.freeze([
		{ value: 0, text: "Nenhum" },
		{ value: 1, text: "União" },
		{ value: 2, text: "Estado" },
		{ value: 3, text: "Distrito Federal" },
		{ value: 4, text: "Município" },
	]),
	GovernmentEntityTypeEnum: Object.freeze({
		NONE: 0,
		FEDERAL_UNION: 1,
		STATE: 2,
		FEDERAL_DISTRICT: 3,
		CITY: 4,
	}),
	GovernmentOperationType: Object.freeze([
		{ value: 0, text: "Nenhum" },
		{ value: 1, text: "Fornecimento" },
		{ value: 2, text: "Recebimento do pagamento" },
	]),
	GovernmentOperationTypeEnum: Object.freeze({
		NONE: 0,
		SUPPLY: 1,
		PAYMENT_RECEIPT: 2,
	}),
	LabelPrintingType: Object.freeze([
		{ value: 0, text: "Normal" },
		{ value: 1, text: "N+" },
		{ value: 2, text: "N+1" }
	]),
	FillingBatchOptionsType: Object.freeze([
		{ value: 0, text: "Nenhum" },
		{ value: 1, text: "Texto" },
		{ value: 2, text: "Data de enchimento" }
	]),
	ReceptionBatchOptionsType: Object.freeze([
		{ value: 0, text: "Nenhum" },
		{ value: 1, text: "Texto" },
		{ value: 2, text: "Data da recepção" }
	]),
	OriginConciliation: Object.freeze({
		Title: 0,
		Launch: 1,
	}),
	TransactionType: Object.freeze({
		None: 0,
		Credit: 1,
		Debit: 2,
	}),
	ReturnOccurrenceType: Object.freeze([
		{ value: "L", text: "Liquidação" },
		{ value: "E", text: "Entrada" },
		{ value: "O", text: "Ocorrência" }
	])
}
